<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-lg">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row">
                    <div class="" style="width:100%; padding: 20px">
                      <iframe
                        title="Share a Success Story"
                        src="https://www.jotform.com/form/200414758515049"
                        width="100%"
                        height="625"
                        frameborder="0"
                        style="border:none;"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [],
  components: {PageLoader},
  data() {
    return {
      isModalShown: true,
    }
  },
  methods: {
    CloseModal() {
      this.$emit('closeWufoo');
    },
    GetAccountValues(){
      var _this = this;
      this.isAccountLoading = true;
      axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
      .then(function (response) {
          _this.Account = response.data.raw;
          _this.ShowWufoo(_this.Account.salesforceId);
      })
      .catch(function (error) {
          console.log(error);
      });
    },
    ShowWufoo(salesforceId) {
      var k1b14hs71wnx3dr;(function(d, t) {
      var s = d.createElement(t), options = {
      'userName':'evf',
      'formHash':'k1b14hs71wnx3dr',
      'autoResize':true,
      'height':'625',
      'async':true,
      'host':'wufoo.com',
      'header':'show',
      'ssl':true,
      'defaultValues':'field6='+ salesforceId +''};
      s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js';
      s.onload = s.onreadystatechange = function() {
      var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return;
      try { k1b14hs71wnx3dr = new WufooForm();k1b14hs71wnx3dr.initialize(options);k1b14hs71wnx3dr.display(); } catch (e) {}};
      var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);
      })(document, 'script');
      this.isWufooLoading = false;
    }
  },
  created() {
    this.isWufooLoading = true;
    this.GetAccountValues();
  },
};
</script>


// WEBPACK FOOTER //
// ShareStoryForm.vue?03520de7